module.exports = new __parcel__URL__("trans-europa-express.b991e0ef.jpg").toString();